import { useEffect } from "react"
import BookingWizardPage from "@/pages/BookingWizard"
import { useBookingStore } from "@/store/booking-store"

export default function BookingModePage() {
  const { setBookingState } = useBookingStore()

  useEffect(() => {
    setBookingState({ bookingStep: "mode" })
  }, [setBookingState])

  return <BookingWizardPage />
}
